import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { AppRouter } from "./router"

// Single client for the whole app. Defaults are tuned to be boring: no
// retries on 4xx (handled inline in hooks), 5-minute stale time for GETs.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  )
}
